// TOC highlight current section
const tableOfContents = document.getElementById('toc');
const articleContent = document.getElementById('article');

if (tableOfContents && articleContent) {
  const sections = Array.from(
    articleContent.querySelectorAll('h2[id], h3[id]')
  );
  const tocLinks = Array.from(
    tableOfContents.querySelectorAll<HTMLAnchorElement>('aside a')
  );
  const offset = 160; // Offset to trigger section change earlier

  function onScroll() {
    let current = sections[0]?.id;
    const scrollPos = window.scrollY + offset;
    sections.forEach((section) => {
      const top = (section as HTMLElement).offsetTop;
      if (scrollPos >= top) current = section.id;
    });

    function isCurrentSection(
      link: HTMLAnchorElement,
      currentId: string
    ): boolean {
      return link.hash === `#${currentId}`;
    }

    tocLinks.forEach((link) => {
      link.setAttribute(
        'aria-current',
        String(isCurrentSection(link, current))
      );
    });
  }

  window.addEventListener('scroll', onScroll, {
    passive: true,
  });

  onScroll();
}
